import axios from "axios";
import getStore from "../store";
import { sessionExpire } from "../actions/UserAction";

/**
 * API Methods
 */
export const GET = "GET";
export const POST = "POST";
export const DELETE = "DELETE";
export const PATCH = "PATCH";
export const PUT = "PUT";

const store = getStore;

/**
 * Base URL
 */
export const DEFAULT_BASEURL = process.env.REACT_APP_APIURL;

const appClient = axios.create({
  baseURL: DEFAULT_BASEURL,
  headers: {
    "Accept-Language": "en",
  },
});

/**
 * Request Interceptor - Add Token
 */
appClient.interceptors.request.use(function (config) {
  if (store) {
    const reduxState = store.getState();
    if (reduxState.userData?.token) {
      config.headers.authorization =
        reduxState.userData.type + " " + reduxState.userData.token;
    }
  }
  return config;
});

/**
 * Response Interceptor
 */
appClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);
    if (error?.response?.status === 401) {
      console.warn("Session expired — redirecting to login…");

      // Clear Local Data
      // store.dispatch(sessionExpire());
      localStorage.clear();
      sessionStorage.clear();

      // Stop further promise chain to avoid React crash
      setTimeout(() => {
        window.location.replace("/login");
      }, 50);

      return new Promise(() => {}); // <-- prevents error propagation
    }

    return Promise.reject(error);
  },
);

/**
 * On Success
 */
const onSuccess = (response) => {
  return response;
};

/**
 * On Failure - return a clean message
 */
const onError = (error) => {
  const message =
    error.response?.data?.message || error.message || "Something went wrong";

  return Promise.reject(message);
};

/**
 * Request Wrapper
 */
export const appRequest = (options) => {
  return appClient(options).then(onSuccess).catch(onError);
};

/**
 * File Upload Wrapper
 */
export const appPost = (url, data, config) => {
  return appClient.post(url, data, config).then(onSuccess).catch(onError);
};

export { appClient };
